import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The old address of a tenancy invoice, kept only as a redirect.
 *
 * The invoice page lives under Bills now, with the Tenancy invoices tab it is opened from, so the
 * sidebar lights the section the operator came from. This address was in use long enough to be
 * bookmarked and pasted into emails, so it forwards rather than falling through to not-found.
 * `replace` so Back does not bounce off it.
 */
export const Route = createFileRoute('/financial/invoices/$ref')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/bills/invoices/$ref', params: { ref: params.ref }, replace: true });
  },
});
